import { Paintbrush } from "./paintbrush";
import { Eyedropper } from "./eyedropper";
import { Floodfill } from "./floodfill";
import { RectangleSelect } from "./rectangleSelect";

export default [RectangleSelect, Paintbrush, Eyedropper, Floodfill];
